import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'

import { dialogInfoAtom } from '../atoms'
import { useInvalidateArchivedStrategyMemosInfiniteQuery } from '../hooks/useArchivedStrategyMemosInfiniteQuery'
import { useUpdateStrategyMemoStatusMutation } from '../hooks/useUpdateStrategyMemoStatusMutation'

export const DeleteStrategyMemoDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { strategyMemo } = dialogInfo

  const resetDialogInfo = useResetAtom(dialogInfoAtom)
  const invalidateArchivedStrategyMemosInfiniteQuery =
    useInvalidateArchivedStrategyMemosInfiniteQuery()
  const updateStrategyMemoStatusMutation = useUpdateStrategyMemoStatusMutation({
    onSuccess: () => {
      invalidateArchivedStrategyMemosInfiniteQuery()
      resetDialogInfo()
    },
  })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    updateStrategyMemoStatusMutation.mutate({
      strategyMemoId: strategyMemo.id,
      newStatus: 'removed',
    })
  }, [strategyMemo.id, updateStrategyMemoStatusMutation])

  return (
    <ExecuteCancelDialog
      executing={updateStrategyMemoStatusMutation.isPending}
      mode="delete"
      title={t('permanently_delete_document')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_completely_confirmation', { target: strategyMemo.title })}
    </ExecuteCancelDialog>
  )
}
